// @gqlflow

import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    UpdateFeedback,
    UpdateFeedbackVariables,
} from "./__graphql-types__/UpdateFeedback.ts";

export const UPDATE_FEEDBACK: GqlOperation<
    UpdateFeedback,
    UpdateFeedbackVariables
> = gqlOp(gql`
    mutation UpdateFeedback(
        $feedbackKey: String!
        $textContent: String!
        $shownLowQualityNotice: Boolean
    ) {
        updateFeedback(
            feedbackKey: $feedbackKey
            textContent: $textContent
            shownLowQualityNotice: $shownLowQualityNotice
        ) {
            feedback {
                isLocked
                isPinned
                appearsAsDeleted
                author {
                    id
                    kaid
                    nickname
                    avatar {
                        name
                        imageSrc
                    }
                }
                content
                date
                definitelyNotSpam
                deleted
                downVoted
                expandKey
                feedbackType
                flaggedBy
                flags
                focusUrl
                focus {
                    kind
                    id
                    translatedTitle
                    relativeUrl
                }
                fromVideoAuthor
                key
                notifyOnAnswer
                permalink
                qualityKind
                replyCount
                replyExpandKeys
                sumVotesIncremented
                upVoted
            }
            lowQualityResponse {
                feedbackCode
                feedbackChar
                feedbackType
                showLowQualityNotice
            }
            error {
                code
            }
        }
    }
`);
